import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Confidentialite = () => {
  return (
    <div className="page">
      <Helmet>
        <title>Politique de confidentialité – Deenzine</title>
        <meta name="description" content="Politique de confidentialité et gestion des données personnelles Deenzine." />
        <link rel="canonical" href={window.location.origin + "/confidentialite"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 900, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Politique de confidentialité</h1>
            <p className="p">
              Le site collecte les données nécessaires à la gestion des commandes (nom, email, adresse).
            </p>

            <div className="hr" />

            <p className="p">
              Ces données sont utilisées uniquement pour le traitement de commande, l’expédition et le service client.
              Elles ne sont jamais revendues à des tiers.
            </p>

            <p className="p" style={{ marginTop: 10 }}>
              Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, de suppression et de portabilité.
              Pour exercer ces droits : <strong>une.developpeuse01@gmail.com</strong>
            </p>

            <p className="p" style={{ marginTop: 10 }}>
              Les données sont stockées de manière sécurisée.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Confidentialite;
